/**
 * @file lib/features.js
 */

import * as TabImages from "../img/illustration-features-*.svg";

export default [
  {
    tabName: "Simple Bookmarking",
    image: TabImages["tab-1"],
    heading: "Bookmark in one click",
    body:
      "Organize your bookmarks however you like. Our simple drag-and-drop interface gives you complete control over how you manage your favorite sites.",
  },
  {
    tabName: "Speedy Searching",
    image: TabImages["tab-2"],
    heading: "Intelligent search",
    body:
      "Our powerful search feature will help you find saved sites in no time at all. No need to trawl through all of your bookmarks.",
  },
  {
    tabName: "Easy Sharing",
    image: TabImages["tab-3"],
    heading: "Share your bookmarks",
    body:
      "Easily share your bookmarks and collections with others. Create a sharable link that you can send at the click of a button.",
  },
];
